<template>
    <BModal :model-value="modal" scrollable centered size="lg" no-close-on-backdrop title="Reservation Form"
        @update:modelValue="updateModal">
        <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="mb-0 title">Reservation Merge Form</h5>
            </div>
            <BButton variant="link" class="close" @click="closeModal">
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>
        <BTabs v-model="activeTabIndex" content-class="mt-3" align="center" justified>
            <BTab title="General" active>
                <BForm>
                    <div class="form-group position-relative">
                        <label>Guest</label>

                        <BFormInput v-model="searchQuery" @focus="isTyped = true" @blur="handleBlur"
                            placeholder="Search guest name" autocomplete="off" />

                        <!-- LOADING -->
                        <span v-if="
                            isTyped &&
                            searchQuery.length >= 2 &&
                            isLoadingGuest
                        " class="text-muted mt-2 d-block">
                            Searching guest...
                        </span>

                        <!-- RESULT LIST -->
                        <BListGroup v-if="
                            isTyped &&
                            searchQuery.length >= 2 &&
                            !isLoadingGuest &&
                            filteredGuestItems.length > 0
                        " class="position-absolute w-100 border rounded-lg bg-white"
                            style="z-index: 10; cursor: pointer">
                            <BListGroupItem v-for="guest in filteredGuestItems" :key="guest.uuid"
                                @mousedown.prevent="selectGuest(guest)" class="p-2 border-0">
                                {{ guest.fullname }}
                            </BListGroupItem>
                        </BListGroup>

                        <!-- NOT FOUND -->
                        <span v-if="
                            isTyped &&
                            searchQuery.length >= 2 &&
                            !isLoadingGuest &&
                            filteredGuestItems.length === 0
                        " class="text-muted mt-2 d-block">
                            Guest not found
                            <router-link to="/guest">Add guest</router-link>
                        </span>

                        <!-- MIN CHARACTER -->
                        <span v-if="
                            isTyped &&
                            searchQuery.length > 0 &&
                            searchQuery.length < 2
                        " class="text-muted mt-2 d-block">
                            Type at least 2 characters to search
                        </span>
                    </div>

                    <div class="form-group">
                        <label for="">Source</label>
                        <BFormSelect v-model="selectedSourceType" :options="sourceTypes" text-field="name"
                            value-field="type" class="">
                            <template #first>
                                <BFormSelectOption :value="null" disabled>
                                    Select Source Type
                                </BFormSelectOption>
                            </template>
                        </BFormSelect>
                    </div>

                    <!-- Pilih Source Detail (hanya untuk type dengan banyak pilihan) -->
                    <div class="form-group" v-if="
                        ['booking_online', 'agent'].includes(selectedSourceType)">

                        <BFormSelect v-model="reservationForm.source_uuid" :options="filteredSourceItems"
                            text-field="name" value-field="uuid">
                            <template #first>
                                <BFormSelectOption :value="null" disabled>
                                    {{
                                        selectedSourceType === "booking_online"
                                            ? "Select Platform"
                                            : "Select Agent"
                                    }}
                                </BFormSelectOption>
                            </template>
                        </BFormSelect>
                    </div>
                    <!-- <div class="form-group" v-if="selectedSourceType === 'booking_online'">
                        <BFormInput type="text" v-model="reservationForm.booking_number"
                            placeholder="Booking Confirmation Number (optional)"></BFormInput>
                    </div> -->
                </BForm>
            </BTab>

            <!-- TAB RESERVATION -->
            <BTab title="Reservation">
                <BForm>
                    <BRow v-for="(item, index) in reservationItems" :key="index" class="mb-3 p-2 border rounded">
                        <!-- Pilih Reservation -->
                        <BCol md="4">
                            <BFormSelect v-model="item.selectedReservationUuid" :options="reservationFormatted"
                                text-field="text" value-field="uuid" @change="
                                    handleSelectReservation(
                                        $event.target.value,
                                        index
                                    )
                                    ">
                                <template #first>
                                    <BFormSelectOption :value="null" disabled>
                                        Select Reservation
                                    </BFormSelectOption>
                                </template>
                            </BFormSelect>
                        </BCol>

                        <!-- Tampilkan Info Guest -->
                        <BCol md="4">
                            <p class="mb-0"><strong>Guest:</strong></p>
                            <p class="text-muted">{{ item.guestName }}</p>
                        </BCol>

                        <!-- Tampilkan Info Room -->
                        <BCol md="4">
                            <p class="mb-0"><strong>Room:</strong></p>
                            <p class="text-muted">
                                {{ item.roomCode }} ({{ item.roomCategory }})
                            </p>
                        </BCol>

                        <!-- Harga -->
                        <BCol md="4">
                            <p class="mb-0"><strong>Price:</strong></p>
                            <p class="text-muted">Rp {{ item.grandTotal }}</p>
                        </BCol>

                        <!-- Status -->
                        <BCol md="4">
                            <p class="mb-0"><strong>Status:</strong></p>
                            <p class="text-muted">{{ item.status }}</p>
                        </BCol>

                        <!-- Tombol Hapus -->
                        <BCol md="12" class="mt-2">
                            <BButton variant="danger" @click="removeReservationItem(index)">
                                <i class="fas fa-trash"></i> Remove
                            </BButton>
                        </BCol>
                    </BRow>

                    <!-- Tombol Add -->
                    <BButton variant="success" @click="addReservationItem">
                        <i class="fas fa-plus"></i> Add Reservation
                    </BButton>

                    <!-- TOTAL -->
                    <div class="d-flex justify-content-end mt-3">
                        <h5>
                            Total Price:
                            <strong>Rp {{ totalPriceBeforeDiscount }}</strong>
                        </h5>
                    </div>
                </BForm>
            </BTab>

            <BTab title="Payment">
                <div class="form-group">
                    <BFormSelect v-model="reservationForm.payment_method_uuid" class="">
                        <template #first>
                            <BFormSelectOption :value="null" disabled>
                                Select payment method
                            </BFormSelectOption>
                        </template>
                        <BFormSelectOption v-for="method in paymentMethods" :key="method.uuid" :value="method.uuid">
                            {{ method.name }} {{ method.number }}
                        </BFormSelectOption>
                    </BFormSelect>
                </div>
                <div class="form-group">
                    <BFormRadioGroup v-model="reservationForm.payment_status" :options="paymentStatus" text-field="text"
                        value-field="text" @change="
                            handleSelectedPaymentStatus($event.target.value)
                            " />
                </div>

                <div class="form-group" v-show="reservationForm.payment_status == 'DP'">
                    <label for="">Grand Total</label>
                    <BFormInput type="number" v-model="reservationForm.grand_total" :value="grandTotal" placeholder="0"
                        disabled>
                    </BFormInput>
                </div>
                <!-- <div class="form-group">
          <label>
            <input type="checkbox" v-model="autoCalculate" />
            Re-calculate
          </label>
        </div> -->

                <div class="form-group" v-show="reservationForm.payment_status == 'DP'">
                    <label for="">Input Pre Payment</label>
                    <BFormInput type="number" v-model="reservationForm.pre_payment" v-if="reservationForm"
                        placeholder="Masukkan nominal">
                    </BFormInput>
                </div>
                <div class="form-group" v-show="reservationForm.payment_status == 'Full Payment'">
                    <label for="">Grand Total</label>
                    <BFormInput type="number" v-model="reservationForm.grand_total" :value="grandTotal" placeholder="0"
                        disabled>
                    </BFormInput>
                </div>
                <div class="form-group">
                    <label for="">Payment Date</label>
                    <BFormInput type="date" v-model="reservationForm.payment_date">
                    </BFormInput>
                </div>

                <div class="form-group">
                    <BFormTextarea v-model="reservationForm.description" placeholder="Remarks(optional)" rows="3" />
                </div>
            </BTab>
        </BTabs>
        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" @click="handleAction" class="mr-2" :disabled="isLoading">
                    {{
                        isLoading
                            ? "Loading..."
                            : reservationData && reservationData.uuid
                                ? "Update"
                                : "Save"
                    }}
                </BButton>
                <BButton variant="danger" @click="closeModal">Cancel</BButton>
                <!-- <BButton variant="info" @click="testEc">tes EC</BButton> -->
            </div>
        </template>
    </BModal>

    <BModal :model-value="modalReschedule" scrollable centered no-close-on-backdrop title="Reservation Reschedule"
        @update:modelValue="updateModal">
        <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="mb-0 title">Reschedule Form</h5>
                <!-- <div class="d-flex gap-2 align-items-center">
          <span class="date">17/02/2025 16:00:00</span>
          <span
            class="bg-success rounded-circle bar-status"
            style="width: 10px; height: 10px"
          ></span>
          <span class="info-status">online: <span>Ruth</span></span>
        </div> -->
            </div>
            <BButton variant="link" class="close" @click="closeModal">
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>
        <!-- <BTabs content-class="mt-3" align="center" justified> -->

        <!-- </BTabs> -->
        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" @click="handleAction" class="mr-2" :disabled="isLoading">
                    {{
                        isLoading
                            ? "Loading..."
                            : reservationData && reservationData.uuid
                                ? "Update"
                                : "Save"
                    }}
                </BButton>
                <BButton variant="danger" @click="closeModal">Cancel</BButton>
                <!-- <BButton variant="info" @click="testEc">tes EC</BButton> -->
            </div>
        </template>
    </BModal>

    <ToastResponse v-model="modalResponse.toast" :text="modalResponse.text" :success="modalResponse.success">
    </ToastResponse>
</template>
<script>
import { ref, computed, watch, nextTick, onMounted, inject } from "vue";
import ToastResponse from "@/components/ToastResponse.vue";
import {
    BModal,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BForm,
    BRow,
    BCol,
    BTabs,
    BTab,
    BFormRadioGroup,
    BListGroup,
    BListGroupItem,
    BButton,
    BFormTextarea,
} from "bootstrap-vue-next";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { formatIDR } from "@/utils/currency";
import CurrencyInput from "vue-currency-input";

export default {
    name: "ReservationForm",
    components: {
        BModal,
        BFormInput,
        BFormSelect,
        BFormSelectOption,
        BButton,
        BForm,
        BRow,
        BCol,
        BTabs,
        BTab,
        BFormTextarea,
        BListGroup,
        BListGroupItem,
        BFormRadioGroup,
        ToastResponse,
        //CurrencyInput,
    },
    props: {
        modal: Boolean,
        modalReschedule: Boolean,
        reservationData: Object,
    },
    emits: [
        "update:modal",
        "update:modalReschedule",
        "update:reservationData",
        "addOrUpdate",
    ],

    setup(props, { emit }) {
        console.log(
            ">>> props.reservationData initial:",
            props.reservationData
        );

        const repositories = inject("repositories");
        const guestRepository = repositories ? repositories.guests : null;
        const paymentMethodRepository = repositories
            ? repositories.paymentMethod
            : null;
        const reservationMergeRepository = repositories
            ? repositories.reservationMerge
            : null;
        const sourceRepository = repositories ? repositories.source : null;

        const isLoading = ref(false);

        const paymentStatus = ref([
            { text: "DP", value: "DP" },
            { text: "Full Payment", value: "Full Payment" },
        ]);
        const selectedPaymentMethod = ref(null);

        const roomCategories = ref([]);
        const selectedRoomCategory = ref(null);
        const rooms = ref([]);
        const selectedRoom = ref(null);
        const guests = ref([]);
        const filteredGuestItems = ref([]);
        const isLoadingGuest = ref(false);
        const sources = ref([]);
        const selectedSourceType = ref(null);
        const selectedSourceItem = ref(null);
        const activeTabIndex = ref(0);
        const extraChargeItems = ref([
            {
                selectedExtraChargeUuid: null,
                selectedExtraChargeCategory: null,
                extracharges: [],
                quantity: 0,
                price: 0,
            },
        ]);
        const extracharges = ref([]);
        const extraChargeCategories = ref([]);
        const selectedExtraChargeCategory = ref(null);
        const selectedExtraChargeItem = ref(null);
        const paymentMethods = ref([]);
        const searchQuery = ref("");
        const isTyped = ref(false);
        const extracharge = ref({});
        const roomItem = ref({
            price: 0,
        });
        const reservation = ref([]);
        const reservationItems = ref([
            {
                selectedReservationUuid: null,
                start: "",
                end: "",
                guestName: "",
                roomCode: "",
                roomCategory: "",
                grandTotal: 0,
                status: "",
                raw: null,
            },
        ]);
        //--tambah auto calculate
        //const autoCalculate = ref(false)

        //**tambahan untuk update harga room price */
        const isEditMode = ref(false);
        const isFormInitializing = ref(false);

        const initialCombination = ref({
            room_uuid: null,
            source_uuid: null,
            start: null,
            end: null,
        });

        const hasUserChangedPriceFields = ref(false);

        const filteredSourceItems = computed(() => {
            //**versi lama */
            if (selectedSourceType.value === "booking_online") {
                return sources.value.filter((item) => item.type === "booking_online");
            } else if (selectedSourceType.value === "agent") {
                return sources.value.filter((item) => item.type === "agent");
            }

            return []; // Return an empty array if no valid type is selected
        });

        const defaultReservationForm = {
            uuid: null,
            extra_charges: [],
            payment_method_uuid: null,
            room_uuid: null,
            guest_uuid: null,
            start: "",
            end: "",
            days: 0,
            discount: 0,
            discount_amount: null,
            grand_total: null,
            description: "",
            payment_status: "DP",
            payment_date: null,
            pre_payment: 0,
            room_category: "",
            //source_uuid: null,
            source_type: null,
            source_detail: null,
            source_name: "",
            guest_fullname: "",
            booking_number: "",
            reservation_price: 0,
            is_high_season: false,
        };

        const reservationForm = ref({ ...defaultReservationForm });

        //membuat input form currency
        const optionsCurrency = {
            currency: "IDR",
            locale: "id-ID",
            distractionFree: false, // true jika ingin format hilang saat fokus
            precision: 0,
        };

        const modalResponse = ref({
            toast: false,
            text: "",
            success: false,
        });

        let echo = null;
        const initEcho = () => {
            window.Pusher = Pusher;
            echo = new Echo({
                broadcaster: "reverb",
                key: import.meta.env.VITE_REVERB_APP_KEY,
                wsHost: import.meta.env.VITE_REVERB_HOST,
                wsPort: import.meta.env.VITE_REVERB_PORT,
                forceTLS: false,
                disableStats: true,
            });

            echo.channel("reservations")
                .listen("ReservationCreated", (event) => {
                    reservationForm.value.push(event.reservation);
                })
                .listen("ReservationUpdated", (event) => {
                    const index = reservationForm.value.findIndex(
                        (r) => r.uuid === event.reservation.uuid
                    );
                    if (index !== -1) {
                        reservationForm.value[index] = event.reservation;
                    }
                })
                .listen("ReservationDeleted", (event) => {
                    reservationForm.value = reservationForm.value.filter(
                        (r) => r.uuid !== event.reservation.uuid
                    );
                });
        };

        const getListGuest = async (params) => {
            await guestRepository
                .getAll(params)
                .then((res) => {
                    guests.value = res.data.data;
                })
                .catch((err) => {
                    console.error(err);
                });
        };

        // handle guest input
        const handleGuestInput = () => {
            isTyped.value = true;
        }
        // fungsi cari guest
        const searchGuests = async (keyword) => {
            if (!keyword || keyword.length < 2) {
                filteredGuestItems.value = [];
                return;
            }
            try {
                const res = await guestRepository.search({ keyword });
                filteredGuestItems.value = res.data.data;
            } catch (err) {
                console.error("Search guest error:", err);
                filteredGuestItems.value = [];
            }
        };

        // Jeda saat mengetik
        const debounce = (fn, delay = 400) => {
            let t;
            return (...args) => {
                clearTimeout(t);
                t = setTimeout(() => {
                    fn(...args);
                }, delay);
            };
        };

        const debouncedSearch = debounce((val) => {
            isLoadingGuest.value = true;

            searchGuests(val)
                .finally(() => {
                    isLoadingGuest.value = false;
                });
        }, 400);

        // trigger otomatis setiap kali searchQuery berubah
        watch(searchQuery, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                isTyped.value = true; // setiap kali ada ketikan baru, buka dropdown lagi
                debouncedSearch(newVal);
            }

            debouncedSearch(newVal);
        });

        const reservationFormatted = computed(() =>
            reservation.value.map(r => ({
                ...r,
                text: `${r.number} (${r.start} to ${r.end})`
            }))
        );

        // ///////////////// BEGIN:LIST RESERVATION //////////////
        const getListReservation = (params) => {
            reservationMergeRepository
                .getReservation(params)
                .then((res) => {
                    reservation.value = res.data.data;
                    console.log("reservation", reservation.value);

                })
                .catch((err) => {
                    console.error(err);
                });
        };

        watch(
            () => [
                reservationForm.value.guest_uuid,
                reservationForm.value.source_uuid,
            ],
            ([newGuestUUID, newSourceUUID]) => {
                if (newGuestUUID && newSourceUUID) {
                    if (!isFormInitializing.value) {
                        reservationItems.value = [
                            {
                                selectedReservationUuid: null,
                                start: "",
                                end: "",
                                guestName: "",
                                roomCode: "",
                                roomCategory: "",
                                grandTotal: 0,
                                status: "",
                                raw: null,
                            },
                        ];
                        console.log(
                            "Fetching reservations for:",
                            newGuestUUID,
                            newSourceUUID
                        );
                    }
                    console.log("params", {
                        guest_uuid: newGuestUUID,
                        source_uuid: newSourceUUID,
                    });
                    getListReservation({
                        guest_uuid: newGuestUUID,
                        source_uuid: newSourceUUID,
                        reservation_merge_uuid: reservationForm.value.uuid || null,
                    });
                }
            }
        );

        // handle memilih reservation
        const handleSelectReservation = (uuid, index) => {
            console.log(
                `Memilih reservation dengan UUID: ${uuid} pada index: ${index}`
            );

            const selected = reservation.value.find((x) => x.uuid === uuid);
            const item = reservationItems.value[index];

            item.raw = selected;
            item.start = selected.start;
            item.end = selected.end;
            item.guestName = selected.guest?.fullname;
            item.roomCode = selected.room?.code;
            item.roomCategory = selected.room?.room_category.name;
            item.grandTotal = selected.grand_total;
            item.status = selected.status;
        };

        // tambah row
        const addReservationItem = () => {
            console.log("Menambahkan baris reservation baru");
            reservationItems.value.push({
                selectedReservationUuid: null,
                start: "",
                end: "",
                guestName: "",
                roomCode: "",
                roomCategory: "",
                roomPrice: 0,
                grandTotal: 0,
                status: "",
                raw: null,
            });

        };

        // hapus row
        const removeReservationItem = (index) => {
            reservationItems.value.splice(index, 1);
        };

        // total harga
        const totalPriceBeforeDiscount = computed(() =>
            reservationItems.value.reduce(
                (t, x) => t + Number(x.grandTotal || 0),
                0
            )
        );
        // ///////////////// END:LIST RESERVATION //////////////

        const getListSource = (params) => {
            sourceRepository
                .getAll(params)
                .then((res) => {
                    sources.value = res.data.data;
                    filteredSourceItems.value = sources.value.filter(
                        (item) => item.type === "agent"
                    );
                })
                .catch((err) => {
                    console.error(err);
                });
        };

        const getListPaymentMethod = () => {
            paymentMethodRepository
                .getAll()
                .then((res) => {
                    paymentMethods.value = [
                        ...res.data.data.filter((i) =>
                            i.status === "active" ? i : null
                        ),
                    ];
                })
                .catch((err) => {
                    console.error(err);
                });
        };

        const create = () => {
            try {
                isLoading.value = true;

                // simpan dulu nilai yg dibutuhkan sebelum assign
                reservationForm.value.reservation_price =
                    totalPriceBeforeDiscount.value;
                const payload = {
                    ...reservationForm.value,
                    grand_total:
                        grandTotal?.value ??
                        reservationForm.value?.grand_total ??
                        0,
                    reservation_items: reservationItems.value
                        .filter(
                            (item) =>
                                item.selectedReservationUuid !== null &&
                                item.raw !== null
                        )
                        .map((item) => ({
                            uuid: item.raw.uuid,
                            start: item.raw.start,
                            end: item.raw.end,
                            grand_total: item.raw.grand_total,
                        })),
                };

                console.log(
                    "Payload yg dikirim ke API:",
                    JSON.stringify(payload, null, 2)
                );

                reservationMergeRepository
                    .create(payload)
                    .then(() => {
                        //updateModal(false);
                        emit("update:modal", false);

                        Object.assign(reservationForm.value, {
                            ...defaultReservationForm,
                        });

                        searchQuery.value = "";
                        selectedRoomCategory.value = null;
                        selectedSourceType.value = null;
                        selectedSourceItem.value = null;
                        activeTabIndex.value = 0;

                        Object.assign(modalResponse.value, {
                            success: true,
                            text: "Reservation merge created successfully",
                            toast: true,
                        });

                        emit("addOrUpdate");
                    })
                    .catch((err) => {
                        Object.assign(modalResponse.value, {
                            success: false,
                            text:
                                err.response?.data?.message ||
                                "Failed to create reservation",
                            toast: true,
                        });
                        console.error("❌ API create error:", err);
                    })
                    .finally(() => {
                        isLoading.value = false;
                    });
            } catch (err) {
                console.error("Create reservation failed:", err);
                isLoading.value = false;
            }
        };

        const update = () => {
            try {
                isLoading.value = true;
                console.log(
                    "Form data sebelum di-update:",
                    JSON.stringify(reservationForm.value, null, 2)
                );

                // simpan dulu nilai yg dibutuhkan sebelum assign
                //const currentDiscount = reservationForm.value.discount || 0;

                reservationForm.value.reservation_price =
                    totalPriceBeforeDiscount.value;
                const payload = {
                    ...reservationForm.value,
                    grand_total:
                        grandTotal?.value ??
                        reservationForm.value?.grand_total ??
                        0,
                    reservation_items: reservationItems.value
                        .filter(
                            (item) =>
                                item.selectedReservationUuid !== null &&
                                item.raw !== null
                        )
                        .map((item) => ({
                            uuid: item.raw.uuid,
                            start: item.raw.start,
                            end: item.raw.end,
                            grand_total: item.raw.grand_total,
                        })),
                };

                console.log(
                    "Payload yg dikirim ke API:",
                    JSON.stringify(payload, null, 2)
                );

                reservationMergeRepository
                    .update(reservationForm.value.uuid, payload)
                    .then(() => {
                        updateModal(false);

                        // Object.assign(reservationForm.value, {});
                        Object.assign(reservationForm.value, {
                            ...defaultReservationForm,
                        });
                        searchQuery.value = "";
                        selectedRoomCategory.value = null;
                        selectedSourceType.value = null;
                        selectedSourceItem.value = null;
                        activeTabIndex.value = 0;

                        Object.assign(modalResponse.value, {
                            success: true,
                            text: "Reservation updated successfully",
                            toast: true,
                        });

                        emit("addOrUpdate");
                    })
                    .catch((err) => {
                        Object.assign(modalResponse.value, {
                            success: false,
                            text:
                                err.response.data.message ||
                                "Failed to update reservation",
                            toast: true,
                        });
                        console.error("❌ API update error:", err);
                    })
                    .finally(() => {
                        isLoading.value = false;
                    });
            } catch (err) {
                console.error("Update reservation failed:", err);
                isLoading.value = false;
            }
        };

        const handleSelectedPaymentStatus = (event) => {
            reservationForm.value.payment_status = event;
        };
        const handleBlur = () => {
            setTimeout(() => {
                isTyped.value = false;
            }, 150);
        };

        const closeModal = () => {
            updateModal(false);
            searchQuery.value = "";
            selectedRoomCategory.value = null;
            selectedSourceType.value = null;
            activeTabIndex.value = 0; // Reset to General tab
        };
        const updateModal = (value) => {
            reservationForm.value = {};
            emit("update:modal", value); // Sync modal state with parent
            emit("update:modalReschedule", value);
        };
        const selectGuest = (guest) => {
            reservationForm.value.guest_uuid = guest.uuid;
            searchQuery.value = guest.fullname;
            nextTick(() => {
                filteredGuestItems.value = [];
            });
            isTyped.value = false;

            //isTyped.value = true;
        };

        const totalExtraChargePrice = computed(() => {
            return extraChargeItems.value.reduce((sum, ext) => {
                const selectedItem = ext.extracharges.find(
                    (item) => item.uuid === ext.selectedExtraChargeUuid
                );
                return (
                    sum + (selectedItem ? selectedItem.price * ext.quantity : 0)
                );
            }, 0);
        });


        const isRoomBillEdited = ref(false);

        // // ** variabel lama */
        // const totalPriceBeforeDiscount = ref(0);

        // watchEffect(() => {
        //   console.log("Source Type:", reservationForm.value.source_type);
        //   console.log(
        //     "Dates:",
        //     reservationForm.value.start,
        //     reservationForm.value.end
        //   );
        //   const selectedRoom = rooms.value.find(
        //     (r) => r.uuid === reservationForm.value.room_uuid
        //   );
        //   console.log("Room Category Prices:", selectedRoom?.room_category?.prices);
        //   console.log("roomPrice:", roomPrice.value);
        // });

        watch(
            [
                () => reservationForm.value.room_uuid,
                () => reservationForm.value.start,
                () => reservationForm.value.end,
                () => reservationForm.value.source_type,
            ],
            (
                [newRoom, newStart, newEnd, newSourceType],
                [oldRoom, oldStart, oldEnd, oldSourceType]
            ) => {
                if (
                    newRoom !== oldRoom ||
                    newStart !== oldStart ||
                    newEnd !== oldEnd ||
                    newSourceType !== oldSourceType
                ) {
                    isRoomBillEdited.value = false;
                }
            }
        );



        // Sinkronisasi: kalau dropdown source_type berubah, update ke reservationForm
        watch(selectedSourceType, (val) => {
            reservationForm.value.source_type = val;
        });

        // Auto-assign source_uuid sesuai kondisi
        watch([selectedSourceType, filteredSourceItems], ([type, items]) => {
            // Skip jika form sedang diinisialisasi (edit mode)
            if (isFormInitializing.value) return;

            if (!type) {
                reservationForm.value.source_uuid = null;
                return;
            }

            if (["walk_in", "direct_booking"].includes(type)) {
                // Walk-in & Direct Booking: langsung pilih source yang sesuai type
                const source = sources.value.find((s) => s.type === type);
                reservationForm.value.source_uuid = source ? source.uuid : null;
            } else if (items.length === 1) {
                // Booking Online & Agent: kalau hasil filter hanya 1 item → auto pilih
                reservationForm.value.source_uuid = items[0].uuid;
            } else if (items.length > 1) {
                // Kalau ada banyak pilihan, cek dulu apakah yang sekarang masih valid
                const isStillValid = items.some(
                    (item) => item.uuid === reservationForm.value.source_uuid
                );
                if (!isStillValid) {
                    reservationForm.value.source_uuid = null;
                }
            }
        });

        const grandTotal = computed(() => {
            return totalPriceBeforeDiscount.value + totalExtraChargePrice.value;
        });

        const sourceTypes = computed(() => {
            const sourceFormat = {
                booking_online: "Booking Online",
                walk_in: "Walk In",
                direct_booking: "Direct Booking",
                agent: "Agent",
            };
            const types = new Set();
            return sources.value
                .filter((item) => {
                    if (!types.has(item.type)) {
                        types.add(item.type);
                        return true;
                    }
                    return false;
                })
                .map((item) => ({
                    type: item.type,
                    name:
                        sourceFormat[item.type] ||
                        item.type.charAt(0).toUpperCase() + item.type.slice(1), // Capitalize for display
                }));
        });

        const handleAction = () => {
            if (isRoomBillEdited.value) {
                reservationForm.value.room_price =
                    totalPriceBeforeDiscount.value || 0;
            }
            // props.reservationData.uuid ? update() : create();

            // gunakan optional chaining agar tidak error saat props masih null/{}.
            if (props.reservationData?.uuid) {
                update();
            } else {
                create();
            }
        };


        const filteredRoomItems = computed(() => {
            return rooms.value.filter(
                (room) => room.room_category.name === selectedRoomCategory.value
            );
        });

        watch(
            () => reservationForm.value.payment_status,
            (newStatus) => {
                if (!reservationForm.value || !newStatus) return; // data belum siap

                //if (autoCalculate.value) {
                reservationForm.value.totalPriceBeforeDiscount =
                    totalPriceBeforeDiscount.value ?? 0;
                reservationForm.value.grand_total = grandTotal.value ?? 0;

                //*codingan lama: madhan*
                if (newStatus === "DP") {
                    reservationForm.value.pre_payment =
                        props.reservationData?.pre_payment ?? 0;
                }
                if (newStatus === "Full Payment") {
                    // Full Payment → tidak ada DP, pre_payment harus 0
                    reservationForm.value.pre_payment = 0;
                    reservationForm.value.payment_date =
                        reservationForm.value.payment_date ||
                        new Date().toISOString().split("T")[0];
                }
            },
            { immediate: false }
        );

        watch(
            () => reservationForm.value.pre_payment,
            (newPrePayment) => {
                const currentGrandTotal = grandTotal.value ?? reservationForm.value.grand_total ?? 0;
                if (currentGrandTotal > 0 && Number(newPrePayment) >= Number(currentGrandTotal)) {
                    reservationForm.value.payment_status = "Full Payment";
                }
            }
        );

        watch(
            () => props.reservationData,
            async (newData) => {
                if (!newData) return;

                isFormInitializing.value = true;
                isEditMode.value = Boolean(newData.uuid);

                // BASIC
                reservationForm.value.uuid = newData.uuid ?? null;
                reservationForm.value.payment_method_uuid =
                    newData.payment_method?.uuid ?? null;
                selectedSourceType.value = newData?.source?.type ?? null;
                reservationForm.value.source_uuid =
                    newData.source?.uuid ?? null;

                reservationForm.value.payment_status =
                    newData.payment_status ?? "DP";
                reservationForm.value.payment_date =
                    newData.payment_date ?? null;
                reservationForm.value.pre_payment = newData.pre_payment ?? 0;
                reservationForm.value.discount = Number(newData.discount ?? 0);
                reservationForm.value.number = newData.number ?? "";
                reservationForm.value.description = newData.description ?? "";
                reservationForm.value.booking_number =
                    newData.booking_number ?? "";

                searchQuery.value = newData.guest?.fullname ?? "";
                filteredGuestItems.value = newData.guest
                    ? [newData.guest]
                    : [];
                reservationForm.value.guest_uuid = newData.guest?.uuid ?? null;


                // RESERVATION ITEMS
                reservationItems.value = Array.isArray(
                    newData.reservation_items
                )
                    ? newData.reservation_items.map((item) => ({
                        selectedReservationUuid: item.reservation?.uuid,
                        guestName: item.reservation?.guest?.fullname ?? "",
                        roomCode: item.reservation?.room?.code ?? "",
                        roomCategory:
                            item.reservation?.room?.room_category?.name ?? "",
                        grandTotal: Number(
                            item.reservation?.grand_total ?? 0
                        ),
                        status: item.reservation?.status ?? "",
                        raw: item.reservation,
                    }))
                    : [];

                await nextTick();

                initialCombination.value = {
                    room_uuid: reservationForm.value.room_uuid,
                    source_uuid: reservationForm.value.source_uuid,
                    start: newData.start ?? null,
                    end: newData.end ?? null,
                };

                reservationForm.value.start = newData.start ?? "";
                reservationForm.value.end = newData.end ?? "";

                hasUserChangedPriceFields.value = false;
                isRoomBillEdited.value = false;
                isFormInitializing.value = false;
            },
            { immediate: true }
        );

        //watch baru untuk mendeteksi
        // perubahan pada bidang yang memengaruhi harga (kamar, sumber, awal, akhir)
        watch(
            [
                () => reservationForm.value.room_uuid,
                () => reservationForm.value.source_uuid,
                () => reservationForm.value.start,
                () => reservationForm.value.end,
            ],
            ([room, source, start, end]) => {
                if (isFormInitializing.value) return;

                const changed =
                    room !== initialCombination.value.room_uuid ||
                    source !== initialCombination.value.source_uuid ||
                    start !== initialCombination.value.start ||
                    end !== initialCombination.value.end;

                if (changed) {
                    hasUserChangedPriceFields.value = true;

                    // // panggil ulang fungsi kalkulasi harga jika sudah ada
                    // if (typeof getRoomPrice === 'function') {
                    //   getRoomPrice(true);
                    // }
                }
            }
        );

        onMounted(() => {
            // getListGuest();
            // getListRoomType();
            getListSource();
            // getListExtraChargeCategory();
            getListPaymentMethod();
            console.log(
                ">>> [onMounted] props.reservationData:",
                props.reservationData
            );
        });

        return {
            isLoading,
            initEcho,
            create,
            updateModal,
            closeModal,
            handleAction,
            handleSelectedPaymentStatus,
            handleBlur,
            selectGuest,
            getListGuest,
            getListSource,
            getListPaymentMethod,
            getListReservation,
            roomCategories,
            rooms,
            roomItem,
            selectedRoomCategory,
            selectedRoom,
            selectedPaymentMethod,
            selectedSourceItem,
            sources,
            filteredSourceItems,
            selectedSourceType,
            selectedExtraChargeCategory,
            selectedExtraChargeItem,
            extraChargeItems,
            extracharges,
            extraChargeCategories,
            extracharge,
            reservationForm,
            paymentMethods,
            paymentStatus,
            guests,
            filteredGuestItems,
            filteredRoomItems,
            totalPriceBeforeDiscount,
            totalExtraChargePrice,
            grandTotal,
            searchQuery,
            isTyped,
            sourceTypes,
            modalResponse,
            formatIDR,
            CurrencyInput,
            optionsCurrency,
            addReservationItem,
            removeReservationItem,
            handleSelectReservation,
            reservationItems,
            reservation,
            reservationFormatted,
            handleGuestInput,
            isLoadingGuest,
            activeTabIndex,
            //autoCalculate,
        };
    },
};
</script>

<style>
@media screen and (max-width: 576px) {
    .modal-title .title {
        font-size: 1rem;
    }

    .modal-title .date,
    .modal-title .info-status {
        font-size: 0.675rem;
    }
}
</style>
